import angular from 'angular';

export class ProductOutcomeController {

  closeWindow: Function;

  data;
  options;
  model;

  /*@ngInject*/
  constructor($scope, Storage, WindowService) {
    this.Storage = Storage;
    this.scope   = $scope;

    this.closeWindow = WindowService.delItem;
  }

  $onInit() {
    this.model = {
      count: 0,
      productId: this.data.product._id,
      type: 'outcome',
      comment: ''
    };
  }

  save() {
    return this.Storage.saveMovement(this.model)
      .then(() => {
        this.close();
      })
      .catch(err => {
        console.error(err);
      });
  }

  close() {
    this.closeWindow(this.data.id);
  }
}



export default angular.module('storageApp.product.outcome', [])
  .component('productOutcome', {
    bindings: {data: '='},
    template: require('./product-outcome.html'),
    transclude: true,
    controller: ProductOutcomeController
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/product-outcome/product-outcome.component.js